module.exports = __webpack_public_path__ + "img/users.e6b26e48.svg";